import React from "react";
import { PROCESS } from "../../mock";

export default function ProcessSection() {
  return (
    <section className="py-24 bg-[#0f2740] text-white overflow-hidden relative">
      <div className="absolute -left-24 top-10 w-72 h-72 rounded-full bg-[#2f9fe6]/10 blur-3xl" />
      <div className="absolute -right-24 bottom-0 w-72 h-72 rounded-full bg-[#2f9fe6]/10 blur-3xl" />
      <div className="container-x relative z-10">
        <div className="text-center max-w-2xl mx-auto mb-16 reveal">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="h-px w-10 bg-[#2f9fe6]" />
            <span className="text-[#7fb8de] tracking-[0.24em] text-xs font-semibold uppercase">Our Process</span>
            <span className="h-px w-10 bg-[#2f9fe6]" />
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
            A clear, structured process
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {PROCESS.map((p, i) => (
            <div key={p.step} className={`reveal delay-${i + 1} relative group`}>
              <div className="font-display text-6xl font-bold text-white/10 mb-4 group-hover:text-[#2f9fe6]/30 transition-colors">{p.step}</div>
              <h3 className="font-display text-xl font-semibold mb-3">{p.title}</h3>
              <p className="text-[#a9c6dd] leading-relaxed text-sm">{p.text}</p>
              <div className="mt-5 h-px w-full bg-white/10 group-hover:bg-[#2f9fe6] transition-colors" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
